import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Header3 from "../../components/header/Header3";
import Footer2 from "../../components/footer2";
import Gotop from "../../components/gotop";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons
import { useParams } from "react-router-dom";
import Breadcrumbuser from "../../components/breadcrumbuser";
import { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import "../../assets/FakeTable.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UserAppointments = () => {
    const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
   const { logout } = useContext(AuthContext);

  const { bookingId } = useParams();
  const navigate = useNavigate();
  const [appointment, setAppointment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [categoryData, setCategoryData] = useState(null);

   const [rating, setRating] = useState(0);
const [hover, setHover] = useState(0);
const [review, setReview] = useState("");

const [alreadyReviewed, setAlreadyReviewed] = useState(false);
const [existingReview, setExistingReview] = useState(null);

useEffect(() => {
  const userId = localStorage.getItem("userId");
  if (!userId || !bookingId) return;

  axios
    .get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/get-review-by-booking", {
      params: { userId, bookingId }
    })
    .then((res) => {
      if (res.data) {
        setAlreadyReviewed(true);
        setExistingReview(res.data);
      }
    })
    .catch((err) => console.error(err));
}, [bookingId]);

const handleReviewSubmit = async () => {
  if (rating === 0 || review.trim() === "") {
    toast.error("Please provide rating and feedback");
    return;
  }

  const userId = localStorage.getItem("userId");

  const data = {
    CustomerId: userId,
    AstrologerId: appointment.AstrologerId || null,
    BookingId: bookingId,
    CategoryName: appointment.Category,
    Rating: rating,
    Feedback: review,
    Status: "pending",
    CreatedAt: new Date().toISOString()
  };

  try {
    await axios.post(
      "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/submit-review-booking",
      data
    );

    // ✅ success toast
    toast.success("Thank you! Your review has been submitted.");

    // ✅ instant UI update
    setAlreadyReviewed(true);
    setExistingReview({
      Rating: rating,
      Feedback: review,
      Status: "pending"
    });

    setRating(0);
    setReview("");
  } catch (err) {
    console.error(err);

    // ❌ error toast
    toast.error("Something went wrong. Please try again.");
  }
};

  useEffect(() => {
    if (!bookingId) return;

    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/appointments/${bookingId}`)
      .then(res => setAppointment(res.data))
      .catch(() => setAppointment(null))
      .finally(() => setLoading(false));
  }, [bookingId]);

  useEffect(() => {
  if (!bookingId) return;

  axios
    .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/appointments/${bookingId}/category-data`)
    .then(res => setCategoryData(res.data))
    .catch(() => setCategoryData(null));
}, [bookingId]);

  const formatDate = (value) => {
    if (!value) return "-";
    const d = value.split("T")[0];
    const [y, m, d2] = d.split("-");
    return `${d2}-${m}-${y}`;
  };

  const formatTime = (value) => {
    if (!value) return "-";
    return value.split("T")[1]?.split(".")[0] + " IST";
  };

 const label = {
  padding: "8px 6px",
  fontSize: 13,
  fontWeight: 600,
  color: "#374151",
  verticalAlign: "top",
  width: "40%"
};

const value = {
  padding: "8px 6px",
  fontSize: 13,
  color: "#111827",
  verticalAlign: "top"
};

const isSelfBooking =
  categoryData?.data?.booking_type?.toLowerCase() === "self";

  if (loading) {
    return <p style={{ textAlign: "center" }}>Loading appointment…</p>;
  }

  if (!appointment) {
    return <p style={{ textAlign: "center" }}>Appointment not found.</p>;
  }

  const topics =
    appointment.TopicNames?.split(",").map(t => t.trim()) || [];


   

  return (
    <>
    <Helmet>
                    <title>Download Invoice - Adhigyanam | Sauntesthyam LLP</title>
                  </Helmet>
                  <div className="menu-mobile-popup">
                <div className="modal-menu__backdrop" onClick={handleMobile}></div>
                <div className="widget-filter">
                  <div className="mobile-header">
                    <div id="logo" className="logo">
                      <Link to="/home">
                        <img className="site-logo" src={logo} alt="Image" />
                      </Link>
                    </div>
                    <Link className="title-button-group" onClick={handleMobile}>
                      <i className="icon-close"></i>
                    </Link>
                  </div>
        
                <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
                  <div className="header-customize-item button" style={{padding: "0px 0px",
            background:"none",
            backgroundColor:"#14a077",
            borderRadius: "4px",
            fontWeight: "700",
            fontSize: "16px",
            lineHeight: "21px",
            color: "white",
            borderColor: "transparent",
            textTransform: "capitalize"}}>
                    <Link to="/userdashboard" style={{color: "#ffffff"}}>Dashboard</Link>
                  </div>
                   
                  
        
                   <div className="mobile-footer">
                    <div className="icon-infor d-flex aln-center">
                      <div className="icon">
                        <span className="icon-call-calling">
                          <span className="path1"></span>
                          <span className="path2"></span>
                          <span className="path3"></span>
                          <span className="path4"></span>
                        </span>
                      </div>
                      <div className="content">
                        <p>Need help? 24/7</p>
                        <h6>
                           <Link to={`tel:918960708425`}>+91-8960708425</Link>
                        </h6>
                      </div>
                    </div>
                    <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
                    <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
                    <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
              <ul className="list-social d-flex aln-center">
                                             <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                             <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                             <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                         </ul>
            </div>
                  </div>
                  <div >
                              <button onClick={logout} className="header-customize-item button" style={{padding: "12px 20px",
            background:"none",
            backgroundColor:"white",
            borderRadius: "4px",
            fontWeight: "700",
            fontSize: "16px",
            lineHeight: "21px",
            color: "black",
            borderColor: "red",
            textTransform: "capitalize"}}>Logout</button>
                            </div>
                </div>
              </div>
      <Header3 clname="act1" handleMobile={handleMobile} />
      <Breadcrumbuser title="Appointment Details" />

      <section style={{ padding: "30px 0" }}>
        <div
          style={{
            maxWidth: 900,
            margin: "auto",
            background: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: 8,
            padding: 24
          }}
        >
          {/* HEADER */}
          <div style={{ marginBottom: 20 }}>
            <h4 style={{ fontSize: 18, fontWeight: 700 }}>
              Booking UID:  #{appointment.Id}
            </h4>
            <p style={{ fontSize: 13, color: "#6b7280" }}>
              Booked on {formatDate(appointment.BookingDate)}
            </p>
          </div>

          {/* STATUS */}
          <div style={{ marginBottom: 20 }}>
            <b>eConsultation Status:</b>{" "}
            <span
              style={{
                fontWeight: 700,
                color:
                  appointment.Status === "Completed"
                    ? "#15803d"
                    : appointment.Status === "Pending"
                    ? "#b45309"
                    : "#374151"
              }}
            >
              {appointment.Status}
            </span>
          </div>
          {/* IMPORTANT SESSION ALERT – ONLY WHEN PENDING */}
{String(appointment.Status).toLowerCase() === "pending" && (
  <div
    style={{
      marginBottom: 20,
      padding: "14px 16px",
      backgroundColor: "#f0fdf4",
      border: "1px solid #86efac",
      borderRadius: 6,
      fontSize: 13,
      color: "#14532d",
      lineHeight: "20px"
    }}
  >
    <b style={{ display: "block", marginBottom: 4 }}>
      Upcoming Session Information
    </b>
    The concerned astrologer will connect with you on the scheduled
    session date and time. You will also receive an advance call alert
    from the <b>Adhigyanam team</b> before the session begins.
  </div>
)}

          {/* SUMMARY */}
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <tbody>
              <tr>
                <td style={{ fontWeight: 600 }}>Category</td>
                <td>{appointment.Category}</td>
              </tr>

              <tr>
                <td style={{ fontWeight: 600 }}>Session Date</td>
                <td>{formatDate(appointment.start_datetime)}</td>
              </tr>

              <tr>
                <td style={{ fontWeight: 600 }}>Start Time</td>
                <td>{formatTime(appointment.start_datetime)}</td>
              </tr>

              <tr>
                <td style={{ fontWeight: 600 }}>Session Duration</td>
                <td>{appointment.user_time} minutes</td>
              </tr>

              <tr>
                <td style={{ fontWeight: 600 }}>Total Price</td>
                <td>
                  ₹{Number(appointment.TotalPrice || 0).toFixed(2)}
                </td>
              </tr>

              <tr>
                <td style={{ fontWeight: 600 }}>Amount Paid</td>
                <td>
                  ₹{Number(appointment.PaidAmount || 0).toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>

          {/* TOPICS */}
          {topics.length > 0 && (
            <div style={{ marginTop: 20 }}>
              <p style={{ fontWeight: 700, fontSize: 13, marginBottom: 8 }}>
                Session Covers - Topics
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {topics.map((t, i) => (
                  <span
                    key={i}
                    style={{
                      background: "#f1f5f9",
                      padding: "6px 12px",
                      borderRadius: 20,
                      fontSize: 12,
                      fontWeight: 600
                    }}
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          )}
<div style={{marginTop:"20px"}}>
          {categoryData?.category === "Personalised Consultation" && categoryData.data && (
  <div>
    <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    The information below was provided by you during booking and will be
    securely shared with the assigned astrologer to prepare for your
    consultation.
  </p>
</div>

    <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 15 }}>
      <tbody>
        <tr>
          <td style={label}>Name:</td>
          <td style={value}>{categoryData.data.Named || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Gender:</td>
          <td style={value}>{categoryData.data.Gender || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Date of Birth:</td>
          <td style={value}>
            {categoryData.data.Dateofbirth
              ? new Date(categoryData.data.Dateofbirth).toLocaleDateString()
              : "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Time of Birth:</td>
          <td style={value}>{categoryData.data.Timeofbirth || "-"} IST</td>
        </tr>

        <tr>
          <td style={label}>Place of Birth:</td>
          <td style={value}>{categoryData.data.Placeofbirth || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Contact Number:</td>
          <td style={value}>{categoryData.data.Cno || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Booking Type:</td>
          <td style={value}>{categoryData.data.BookingType || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Calling Number:</td>
          <td style={value}>{categoryData.data.CallingNumber || "-"}</td>
        </tr>
      </tbody>
    </table>
  </div>
)}
{categoryData?.category === "Match Making" && categoryData.data && (
  <div>
   <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    The information below was provided by you during booking and will be
    securely shared with the assigned astrologer to prepare for your
    consultation.
  </p>
</div>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginBottom: 15
      }}
    >
      <tbody>
        <tr>
          <td style={label}>Male Name:</td>
          <td style={value}>{categoryData.data.MaleName || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Male Date of Birth:</td>
          <td style={value}>
            {categoryData.data.MaleDOB
              ? new Date(categoryData.data.MaleDOB).toLocaleDateString()
              : "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Male Time of Birth:</td>
          <td style={value}>
            {categoryData.data.MaleTOB || "-"} IST
          </td>
        </tr>

        <tr>
          <td style={label}>Male Place of Birth:</td>
          <td style={value}>{categoryData.data.MalePOB || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Female Name:</td>
          <td style={value}>{categoryData.data.FemaleName || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Female Date of Birth:</td>
          <td style={value}>
            {categoryData.data.FemaleDOB
              ? new Date(categoryData.data.FemaleDOB).toLocaleDateString()
              : "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Female Time of Birth:</td>
          <td style={value}>
            {categoryData.data.FemaleTOB || "-"} IST
          </td>
        </tr>

        <tr>
          <td style={label}>Female Place of Birth:</td>
          <td style={value}>{categoryData.data.FemalePOB || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Contact Number:</td>
          <td style={value}>{categoryData.data.Cno || "-"}</td>
        </tr>
      </tbody>
    </table>
  </div>
)}
{categoryData?.category === "Married Life Analysis" && categoryData.data && (
  <div>
    <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    The information below was provided by you during booking and will be
    securely shared with the assigned astrologer to prepare for your
    consultation.
  </p>
</div>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginBottom: 15
      }}
    >
      <tbody>
        <tr>
          <td style={label}>Husband Name:</td>
          <td style={value}>{categoryData.data.HusbandName || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Husband Date of Birth:</td>
          <td style={value}>
            {categoryData.data.HusbandDOB
              ? new Date(categoryData.data.HusbandDOB).toLocaleDateString()
              : "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Husband Time of Birth:</td>
          <td style={value}>
            {categoryData.data.HusbandTOB || "-"} IST
          </td>
        </tr>

        <tr>
          <td style={label}>Husband Place of Birth:</td>
          <td style={value}>{categoryData.data.HusbandPOB || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Wife Name:</td>
          <td style={value}>{categoryData.data.WifeName || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Wife Date of Birth:</td>
          <td style={value}>
            {categoryData.data.WifeDOB
              ? new Date(categoryData.data.WifeDOB).toLocaleDateString()
              : "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Wife Time of Birth:</td>
          <td style={value}>
            {categoryData.data.WifeTOB || "-"} IST
          </td>
        </tr>

        <tr>
          <td style={label}>Wife Place of Birth:</td>
          <td style={value}>{categoryData.data.WifePOB || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Contact Number:</td>
          <td style={value}>{categoryData.data.Cno || "-"}</td>
        </tr>
      </tbody>
    </table>
  </div>
)}
{categoryData?.category === "Business Partnership & Compatibility Analysis" &&
  Array.isArray(categoryData.data) &&
  categoryData.data.length > 0 && (
    <div>
      <div style={{ marginBottom: 12 }}>
        <p
          style={{
            fontWeight: 700,
            fontSize: 14,
            color: "#0f172a",
            marginBottom: 4,
            textTransform: "uppercase",
            letterSpacing: "0.04em"
          }}
        >
          User Submitted Information
        </p>

        <p
          style={{
            fontSize: 12,
            color: "#6b7280",
            lineHeight: "18px",
            marginBottom: 10
          }}
        >
          The details below were provided during booking and are securely
          shared with the assigned astrologer for compatibility analysis.
        </p>
      </div>

      <div
        style={{
          border: "1px solid #e5e7eb",
          borderRadius: 8,
          overflow: "hidden",
          background: "#ffffff",
          marginBottom: 20
        }}
      >
        <table
          style={{
            width: "100%",
            tableLayout: "fixed",
            borderCollapse: "collapse",
            fontSize: 13
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f1f5f9" }}>
              <th style={{ padding: 10, width: "22%", textAlign: "left" }}>
                Name
              </th>
              <th style={{ padding: 10, width: "12%", textAlign: "left" }}>
                Gender
              </th>
              <th style={{ padding: 10, width: "18%", textAlign: "left" }}>
                Date of Birth
              </th>
              <th style={{ padding: 10, width: "18%", textAlign: "left" }}>
                Time of Birth
              </th>
              <th style={{ padding: 10, width: "30%", textAlign: "left" }}>
                Place of Birth
              </th>
            </tr>
          </thead>

          <tbody>
            {categoryData.data.map((person, idx) => (
              <tr
                key={idx}
                style={{
                  borderTop: "1px solid #e5e7eb",
                  backgroundColor: idx % 2 === 0 ? "#ffffff" : "#fafafa"
                }}
              >
                <td style={{ padding: 10, fontWeight: 600 }}>
                  {person.Named || "-"}
                </td>

                <td style={{ padding: 10 }}>
                  {person.Gender || "-"}
                </td>

                <td style={{ padding: 10 }}>
                  {person.Dateofbirth
                    ? new Date(person.Dateofbirth).toLocaleDateString()
                    : "-"}
                </td>

                <td style={{ padding: 10 }}>
                  {person.Timeofbirth || "-"} IST
                </td>

                <td
                  style={{
                    padding: 10,
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    color: "#374151"
                  }}
                >
                  {person.Placeofbirth || "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )}
{categoryData?.category === "Child Name Analysis" && categoryData.data && (
  <div>
   <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    The information below was provided by you during booking and will be
    securely shared with the assigned astrologer to prepare for your
    consultation.
  </p>
</div>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginBottom: 15
      }}
    >
      <tbody>
        <tr>
          <td style={label}>Gender:</td>
          <td style={value}>{categoryData.data.Gender || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Date of Birth:</td>
          <td style={value}>
            {categoryData.data.Dateofbirth
              ? new Date(categoryData.data.Dateofbirth).toLocaleDateString()
              : "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Time of Birth:</td>
          <td style={value}>
            {categoryData.data.Timeofbirth || "-"} IST
          </td>
        </tr>

        <tr>
          <td style={label}>Place of Birth:</td>
          <td style={value}>{categoryData.data.Placeofbirth || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Preferred Name Option 1:</td>
          <td style={{ ...value, fontWeight: 700 }}>
            {categoryData.data.Option1 || "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Preferred Name Option 2:</td>
          <td style={{ ...value, fontWeight: 700 }}>
            {categoryData.data.Option2 || "-"}
          </td>
        </tr>

        <tr>
          <td style={label}>Preferred Name Option 3:</td>
          <td style={{ ...value, fontWeight: 700 }}>
            {categoryData.data.Option3 || "-"}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
)}
{categoryData?.category === "Birth Time Rectification" &&
  categoryData.data && (
    <div>
     <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    The information below was provided by you during booking and will be
    securely shared with the assigned astrologer to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Date of Birth:</td>
            <td style={value}>
              {categoryData.data.Dateofbirth
                ? new Date(
                    categoryData.data.Dateofbirth
                  ).toLocaleDateString()
                : "-"}
            </td>
          </tr>

          <tr>
            <td style={label}>Place of Birth:</td>
            <td style={value}>{categoryData.data.Placeofbirth || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Birth Time Window:</td>
            <td style={value}>
              {categoryData.data.BirthTimeStart || "-"} –{" "}
              {categoryData.data.BirthTimeEnd || "-"} IST
            </td>
          </tr>

          <tr>
            <td style={label}>Height Unit:</td>
            <td style={value}>{categoryData.data.HeightUnit || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* Optional Image */}
      {categoryData.data.Image1 && (
        <div style={{ marginTop: 10 }}>
          <p style={{ ...label, marginBottom: 6 }}>
            Customer Uploaded Image
          </p>
          <img
            src={categoryData.data.Image1}
            alt="Birth Time Reference"
            style={{
              maxWidth: "220px",
              borderRadius: 8,
              border: "1px solid #e5e7eb"
            }}
          />
        </div>
      )}
    </div>
  )}
{categoryData?.category === "Tarot Card Reading" &&
  categoryData.data && (
    <div>
     <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    The information below was provided by you during booking and will be
    securely shared with the assigned astrologer to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Date of Birth:</td>
            <td style={value}>
              {categoryData.data.Dateofbirth
                ? new Date(
                    categoryData.data.Dateofbirth
                  ).toLocaleDateString()
                : "-"}
            </td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )}
{categoryData?.category === "Palmistry" &&
  categoryData.data && (
    <div>
      <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    The information below was provided by you during booking and will be
    securely shared with the assigned astrologer to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Date of Birth:</td>
            <td style={value}>
              {categoryData.data.Dateofbirth
                ? new Date(
                    categoryData.data.Dateofbirth
                  ).toLocaleDateString()
                : "-"}
            </td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* Palm Images */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
        {[1, 2, 3, 4].map((i) => {
          const img = categoryData.data[`Image${i}`];
          if (!img) return null;

          return (
            <div key={i}>
              <img
                src={img}
                alt={`Palm Image ${i}`}
                style={{
                  maxWidth: "180px",
                  borderRadius: 8,
                  border: "1px solid #e5e7eb"
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  )}
{categoryData?.category === "Face Reading" &&
  categoryData.data && (
    <div>
      <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    The information below was provided by you during booking and will be
    securely shared with the assigned astrologer to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* Face Images */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
        {[1, 2, 3].map((i) => {
          const img = categoryData.data[`Image${i}`];
          if (!img) return null;

          return (
            <div key={i}>
              <img
                src={img}
                alt={`Face Image ${i}`}
                style={{
                  maxWidth: "180px",
                  borderRadius: 8,
                  border: "1px solid #e5e7eb"
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  )}
{categoryData?.category === "Handwriting Analysis" &&
  categoryData.data && (
    <div>
     <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    The information below was provided by you during booking and will be
    securely shared with the assigned astrologer to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Date of Birth:</td>
            <td style={value}>
              {categoryData.data.Dateofbirth
                ? new Date(
                    categoryData.data.Dateofbirth
                  ).toLocaleDateString()
                : "-"}
            </td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* Handwriting Image */}
      {categoryData.data.Image1 && (
        <div style={{ marginTop: 10 }}>
          <img
            src={categoryData.data.Image1}
            alt="Handwriting Sample"
            style={{
              maxWidth: "220px",
              borderRadius: 8,
              border: "1px solid #e5e7eb"
            }}
          />
        </div>
      )}
    </div>
  )}
{categoryData?.category === "Signature Analysis" &&
  categoryData.data && (
    <div>
     <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    The information below was provided by you during booking and will be
    securely shared with the assigned astrologer to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Date of Birth:</td>
            <td style={value}>
              {categoryData.data.Dateofbirth
                ? new Date(
                    categoryData.data.Dateofbirth
                  ).toLocaleDateString()
                : "-"}
            </td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* Signature Image */}
      {categoryData.data.Image1 && (
        <div style={{ marginTop: 10 }}>
          <img
            src={categoryData.data.Image1}
            alt="Signature Sample"
            style={{
              maxWidth: "220px",
              borderRadius: 8,
              border: "1px solid #e5e7eb"
            }}
          />
        </div>
      )}
    </div>
  )}
{categoryData?.category === "Numerology" &&
  categoryData.data && (
    <div>
      <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    The information below was provided by you during booking and will be
    securely shared with the assigned astrologer to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Date of Birth:</td>
            <td style={value}>
              {categoryData.data.Dateofbirth
                ? new Date(
                    categoryData.data.Dateofbirth
                  ).toLocaleDateString()
                : "-"}
            </td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )}
{categoryData?.category === "Vastu Analysis" &&
  categoryData.data && (
    <div>
      <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    The information below was provided by you during booking and will be
    securely shared with the assigned astrologer to prepare for your
    consultation.
  </p>
</div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Contact Number:</td>
            <td style={value}>{categoryData.data.Cno || "-"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )}
{categoryData?.category === "Hand Made Kundali Report" &&
  categoryData.data && (
    <div>
     <div style={{ marginBottom: 12 }}>
  <p
    style={{
      fontWeight: 700,
      fontSize: 14,
      color: "#0f172a",
      marginBottom: 4,
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    User Submitted Information
  </p>

  <p
    style={{
      fontSize: 12,
      color: "#6b7280",
      lineHeight: "18px",
      marginBottom: 10
    }}
  >
    The information below was provided by you during booking and will be
    securely shared with the assigned astrologer to prepare for your
    consultation.
  </p>
</div>

      {/* Birth Details */}
      <p style={{ fontWeight: 600, marginBottom: 6 }}>Birth Details</p>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 15
        }}
      >
        <tbody>
          <tr>
            <td style={label}>Name:</td>
            <td style={value}>{categoryData.data.Named || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Gender:</td>
            <td style={value}>{categoryData.data.Gender || "-"}</td>
          </tr>

          <tr>
            <td style={label}>Date of Birth:</td>
            <td style={value}>
              {categoryData.data.Dateofbirth
                ? new Date(
                    categoryData.data.Dateofbirth
                  ).toLocaleDateString()
                : "-"}
            </td>
          </tr>

          <tr>
            <td style={label}>Time of Birth:</td>
            <td style={value}>
              {categoryData.data.Timeofbirth || "-"} IST
            </td>
          </tr>

          <tr>
            <td style={label}>Place of Birth:</td>
            <td style={value}>{categoryData.data.Placeofbirth || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* Delivery Details */}
     {/* Delivery Details */}
<p style={{ fontWeight: 600, marginBottom: 6 }}>
  Delivery Information
</p>

<table
  style={{
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: 15
  }}
>
  <tbody>
    <tr>
      <td style={label}>Booking Type:</td>
      <td style={value}>{categoryData.data.booking_type || "-"}</td>
    </tr>

    {!isSelfBooking && (
      <>
        <tr>
          <td style={label}>Recipient Name:</td>
          <td style={value}>{categoryData.data.fullname || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Mobile Number:</td>
          <td style={value}>{categoryData.data.mobilenumber || "-"}</td>
        </tr>

        <tr>
          <td style={label}>Address:</td>
          <td style={value}>
            {[
              categoryData.data.flat,
              categoryData.data.area,
              categoryData.data.landmark,
              categoryData.data.city,
              categoryData.data.state,
              categoryData.data.pincode
            ]
              .filter(Boolean)
              .join(", ")}
          </td>
        </tr>
      </>
    )}
  </tbody>
</table>
    </div>
  )}
  </div>

          {/* ASTROLOGER */}
          <div style={{ marginTop: 24 }}>
  <p
    style={{
      fontWeight: 700,
      marginBottom: 10,
      fontSize: 14,
      color: "#111827",
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }}
  >
    Assigned Astrologer
  </p>

  <div
    style={{
      display: "flex",
      gap: 14,
      alignItems: "center",
      padding: "12px 14px",
      border: "1px solid #e5e7eb",
      borderRadius: 8,
      background: "#fafafa"
    }}
  >
    <img
      src={appointment.AstrologerPhoto || "/siteimages/favicon.png"}
      alt="Astrologer"
      style={{
        width: 64,
        height: 64,
        borderRadius: "50%",
        objectFit: "cover",
        border: "1px solid #e5e7eb",
        background: "#fff"
      }}
    />

    <div>
      <div
        style={{
          fontWeight: 700,
          fontSize: 15,
          color: "#0f172a"
        }}
      >
        {appointment.AstrologerName || "Assigned Astrologer"}
      </div>

      <div
        style={{
          fontSize: 12,
          color: "#6b7280",
          marginTop: 2
        }}
      >
        Professional Astrologer • Adhigyanam
      </div>
    </div>
  </div>
</div>


{String(appointment.Status).toLowerCase() === "completed" && ( 
  <div
    style={{
      marginTop: 25,
      padding: "20px",
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      backgroundColor: "#fafafa"
    }}
  >
    <h6 style={{ fontWeight: "700", fontSize: "17px" }}>
      Share Your Experience
    </h6>

    <p style={{ marginBottom: "15px", fontSize: "14px" }}>
      Your feedback helps us improve and guide other users.
    </p>

    {alreadyReviewed ? (
      <div
        style={{
          backgroundColor: "white",
          padding: "15px",
          borderRadius: "6px",
          border: "1px solid #d4edda"
        }}
      >
       <p><b>Your Rating:</b></p>

    <div>
      {[1,2,3,4,5].map((star) => (
        <span
          key={star}
          style={{
            fontSize: "24px",
            color: existingReview?.Rating >= star ? "#FFD700" : "#ccc"
          }}
        >
          ★
        </span>
      ))}
    </div>

    <p style={{ marginTop: "10px" }}>
      <b>Your Feedback:</b><br />
      {existingReview?.Feedback}
    </p>

        {/* <p style={{ fontSize: "12px", color: "#777" }}>
          Status: Under Review
        </p> */}
      </div>
    ) : (
      <>
        {/* Stars */}
        <div style={{ marginBottom: "10px" }}>
          {[1,2,3,4,5].map((star) => (
            <span
              key={star}
              onClick={() => setRating(star)}
              onMouseEnter={() => setHover(star)}
              onMouseLeave={() => setHover(0)}
              style={{
                fontSize: "28px",
                cursor: "pointer",
                color: (hover || rating) >= star ? "#FFD700" : "#ccc"
              }}
            >
              ★
            </span>
          ))}
        </div>

        {/* Feedback */}
        <textarea
          placeholder="Write your experience..."
          value={review}
          onChange={(e) => setReview(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            marginBottom: "10px", backgroundColor:"white"
          }}
        />

        <button
          onClick={handleReviewSubmit}
          style={{
            backgroundColor: "#14a077",
            color: "white",
            padding: "10px 15px",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: "bold"
          }}
        >
          Submit Review
        </button>
      </>
    )}
  </div>
)} 

          {/* ACTIONS */}
          <div
            style={{
              marginTop: 30,
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <button
              onClick={() => navigate(-1)}
              style={{
                background: "#f3f4f6",
                border: "1px solid #d1d5db",
                padding: "8px 14px",
                borderRadius: 6,
                fontWeight: 600
              }}
            >
              ← Back
            </button>

            <Link
              to={`/appointmentinvoice/${appointment.Id}`}
              style={{
                background: "#14a077",
                color: "#fff",
                padding: "10px 18px",
                borderRadius: 6,
                fontWeight: 700,
                textDecoration: "none"
              }}
            >
              View Invoice
            </Link>
          </div>
        </div>
      </section>
<ToastContainer
  position="bottom-center"
  autoClose={4000}
  hideProgressBar={false}
  closeOnClick
  pauseOnHover
  draggable
/>
      <Footer2 />
    </>
  );
};

export default UserAppointments;